<script setup>
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { formatDate } from '@/lib/date_helper.js'

const props = defineProps({
  service_history: {
    type: Object,
    required: true,
  }
})

// I18n
const { t } = useI18n();

// Variables
const isLoading = ref(true);

onMounted(async () => { });

</script>

<template>
  <RouterLink :to="{name: 'all_quotes', params: {id: service_history.user_quote_id}}">
    <img src="../../../assets/images/service-center-standards.jpg" class="h-[100px] w-full object-cover rounded-t-xl" />
    <div class="absolute w-full quote-header-overlay rounded-t-xl h-[100px]">
      <div class="p-4 w-full">
        <div class="flex flex-col">
          <div v-if="service_history.title" class="flex items-start gap-2">
            <div class="flex-shrink-0 mt-1">
              <span v-if="service_history.job_status === 'completed' || service_history.job_status === 'historical'" class="inline-flex items-center justify-center w-4 h-4 rounded-full bg-green-100" :title="service_history.job_status === 'historical' ? 'Historical' : 'Completed'">
                <svg class="w-2.5 h-2.5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
                </svg>
              </span>
              <span v-else-if="service_history.job_status === 'expired' || service_history.job_status === 'stale'" class="inline-flex items-center justify-center w-4 h-4 rounded-full bg-gray-200" :title="service_history.job_status === 'stale' ? 'Stale' : 'Expired'">
                <svg class="w-2.5 h-2.5 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd"/>
                </svg>
              </span>
              <span v-else class="inline-flex items-center justify-center w-4 h-4 rounded-full bg-blue-100" title="In Progress">
                <svg class="w-2.5 h-2.5 text-blue-600 animate-spin" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              </span>
            </div>
            <p class="font-semibold text-xl line-clamp-3 my-auto flex-1">
              {{ service_history.title }}
            </p>
          </div>

        </div>
      </div>
    </div>
    <div class="flex flex-col">
      <div class="p-4">
        <p v-if="service_history.description" class="line-clamp-6 my-auto">
          {{ service_history.description }}
        </p>
        <p v-if="service_history.user_vehicle_service_histories && service_history.user_vehicle_service_histories[0] && service_history.user_vehicle_service_histories[0].status === 'cancelled'" class="font-semibold pt-2">{{ t('my_garage.quote_card.cancelled') }}</p>
        <p v-else-if="service_history.job_status === 'completed' || service_history.job_status === 'historical'" class="font-semibold pt-2">
          {{ t('my_garage.quote_card.completed', { date: formatDate(service_history.completion_date || service_history.updated_at) }) }}
        </p>
        <p v-else-if="service_history.job_status === 'expired' || service_history.job_status === 'stale'" class="font-semibold pt-2">
          {{ service_history.job_status === 'stale' ? t('my_garage.quotes.quote_stale') : t('my_garage.quotes.quote_expired') }}
        </p>
        <p v-else class="font-semibold pt-2">
          {{ t('my_garage.quote_card.incomplete') }}
        </p>
      </div>
    </div>
  </RouterLink>
</template>

<style lang="scss" scoped>
@import '@/assets/styles/views/my_garage/my_garage';
</style>
